import { useEffect, useRef, useState } from "react"
import { BoxProps } from "@chakra-ui/react"
import { useLocation } from "react-router-dom"
import { ClientData, PageData } from "types"

import { Layout } from "components/Layout"

interface LayoutProviderProps extends BoxProps {
  clientData: ClientData
}

export const LayoutProvider = ({
  clientData,
  ...rest
}: LayoutProviderProps) => {
  const { pages, layout } = clientData ?? {}
  const location = useLocation()

  const [currentPage, setCurrentPage] = useState<PageData>()

  useEffect(
    function determineCurrentPage() {
      setCurrentPage(
        pages?.find(pageData => pageData.slug === location.pathname.slice(1)),
      )
    },
    [location, pages],
  )

  const navRef = useRef<HTMLElement>(null)
  const mainRef = useRef<HTMLDivElement>(null)

  const layoutVersion = !currentPage || !layout ? "centered" : layout.version

  const layoutProps = {
    clientData,
    navRef,
    mainRef,
    currentPage,
    layout: { version: layoutVersion },
    ...rest,
  }

  return <Layout {...layoutProps} />
}
